{
  "en": {
    "filteredTable": {
      "actions": {
        "unselect": "Unselect all Selected"
      },
      "labels": {
        "selected": "%{count} Selected"
      },
      "empty": {
        "info": "We could not find any Records."
      }
    }
  }
}
